import * as Sentry from '@sentry/react'

export function identifySentryUser(
  user: { id: string; email?: string | null },
  tenantId: string | null,
) {
  Sentry.setUser({ id: user.id, email: user.email ?? undefined })
  if (tenantId) {
    Sentry.setTag('tenant_id', tenantId)
  }
}

export function clearSentryUser() {
  Sentry.setUser(null)
  Sentry.setTag('tenant_id', null)
}
